// extracted by mini-css-extract-plugin
module.exports = {"container":"RenderMarkdownMarked_container__P_YGs"};